import {
  CHANGE_IS_FETCHING_MODULE,
  CLEAR_UPGRADE_MODULES_STORE,
  SET_CURRENT_UPGRADE_MODULE_ID,
  SET_MODULE_STATUS,
  SET_MODULE_WITH_INITIAL_INPROGRESS_STATUS,
  SET_UPGRADE_MODULES,
  UPDATE_MODULE_STATUS_AND_LOGS,
} from '../actions/UpgradeModulesActions';

const initialState = {
  modules: [],
  isFetchingModule: false,
  currentUpgradeModuleId: null,
  formConversionLogFile: {},
  moduleWithInitialInProgressStatus: null,
};

const upgradeModulesReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_UPGRADE_MODULES: {
      const { modules, formConversionLogFile } = action.payload;

      return {
        ...state,
        modules,
        formConversionLogFile,
      };
    }

    case CHANGE_IS_FETCHING_MODULE: {
      const { flag } = action.payload;

      return {
        ...state,
        isFetchingModule: flag,
      };
    }

    case SET_CURRENT_UPGRADE_MODULE_ID: {
      const { moduleId } = action.payload;

      return {
        ...state,
        currentUpgradeModuleId: moduleId,
      };
    }

    case UPDATE_MODULE_STATUS_AND_LOGS: {
      const { module, formConversionLogFile } = action.payload;

      return {
        ...state,
        modules: state.modules.map((m) => {
          if (m.Id === module.Id) {
            return {
              ...module,
              Log: module.Log ?? [],
            };
          }
          return m;
        }),
        formConversionLogFile,
      };
    }

    case SET_MODULE_STATUS: {
      const { moduleId, status } = action.payload;

      return {
        ...state,
        modules: state.modules.map((m) => {
          if (m.Id === moduleId) {
            return {
              ...m,
              Status: status,
            };
          }
          return m;
        }),
      };
    }

    case SET_MODULE_WITH_INITIAL_INPROGRESS_STATUS: {
      const { module } = action.payload;

      return {
        ...state,
        moduleWithInitialInProgressStatus: module,
      };
    }

    case CLEAR_UPGRADE_MODULES_STORE: {
      return initialState;
    }

    default:
      return state;
  }
};

export default upgradeModulesReducer;
